'use strict';
module.exports = require('../../full/symbol');



//////////////////
// WEBPACK FOOTER
// ./~/react-app-polyfill/~/core-js/features/symbol/index.js
// module id = 1935
// module chunks = 0